var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.657 30h7.971a13.09 13.09 0 0 0 9.274-3.855 13.185 13.185 0 0 0 3.84-9.306V15.16c0-3.49-1.381-6.837-3.84-9.305A13.09 13.09 0 0 0 16.628 2H3v5.806h11.828c2.183 0 4.276.87 5.819 2.42a8.273 8.273 0 0 1 2.41 5.839c0 2.19-.867 4.29-2.41 5.839a8.214 8.214 0 0 1-5.818 2.419H8.656V30zM5.83 13.355c-.752 0-1.471.299-2.002.831a2.844 2.844 0 0 0 0 4.015c.53.533 1.25.832 2 .832v-5.677zm8.87 5.677h-3.343v-5.677H14.7c.75 0 1.47.299 2 .831a2.844 2.844 0 0 1 0 4.015c-.53.533-1.25.832-2 .832z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDad);
export default __webpack_public_path__ + "static/media/DAD.ef0e9d1b5fb96028d341e98e25626a0f.svg";
export { ForwardRef as ReactComponent };